import copy from 'copy-to-clipboard'
import Image from 'next/image'
import SvgCopy from '#/assets/images/icons/copy.svg'
import Button from '#/components/Button'
import Snackbar from '#/components/Snackbar'
import api from '#/configs/api'
import { logEvent } from '#/services/analytics'
import cn from '#/utils/classnames'

type Props = {
  rets: TopHap.ListingTransaction
  mls: TopHap.PropertiesState['mls'] | undefined
  property: TopHap.Property
}

function copyLink(link: string) {
  copy(link)
  Snackbar.show({ message: 'MLS ID copied to clipboard.' })
  logEvent('select_content', {
    content_type: 'property_detail',
    item_id: 'copy_mls',
    value: link
  })
}

const DataSource: React.FC<Props> = ({ rets, mls, property }) => {
  const mlsId = rets.ListingId

  if (!mlsId) return null
  const showImage = property.mls && mls && mls[property.mls] && mls[property.mls].logo !== undefined

  return (
    <div
      className={cn(
        'flex flex-row justify-between items-center mt-4',
        { 'justify-end': !showImage }
      )}
    >
      {showImage && (
        <Image
          alt={property.mls || ''}
          className='h-5 object-contain object-left'
          height={20}
          src={property.mls ? `${api.assetsBaseUrl}/mls/${mls[property.mls].logo}` : ''}
          width={96}
        />
      )}
      <div className='flex flex-row items-center'>
        <Button className='text-gray-400' onClick={() => copyLink(mlsId)}>
          <div className='align-middle text-sm text-gray-400'>
            {' '}
            MLS#
            {' '}
            {mlsId}
          </div>
          <SvgCopy className='ml-1' />
        </Button>
      </div>
    </div>
  )
}

export default DataSource
